const transitionDurations = [0.2, 0.4, 0.6, 0.8]

export default transitionDurations
